module.exports = __webpack_public_path__ + "img/container2Icon4.bd9bc225.png";